import { render, staticRenderFns } from "./MenuRadiale.vue?vue&type=template&id=04810d38&scoped=true&"
import script from "./MenuRadiale.vue?vue&type=script&lang=js&"
export * from "./MenuRadiale.vue?vue&type=script&lang=js&"
import style0 from "./MenuRadiale.vue?vue&type=style&index=0&id=04810d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04810d38",
  null
  
)

export default component.exports